export enum PdfAnnotationAction {
    None = 0,
    Select,
    Text,
    Pencil,
    Highlight,
    Rectangle,
    Eraser,
    Undo,
    Redo,
    Check,
    Cross,
    R3,
    R6,
    R12,
    R24,
    Signature,
    Clear,
    ZoomIn,
    ZoomOut,
    Open
}
